import dataSourcesApi from '@facility/dataSources/api/dataSourcesApi';
import { ExternalSourceLoadResult, toExternalSourceCandidate } from './types';

function getErrorMessage(error: unknown): string {
    if (error && typeof error === 'object' && 'message' in error) {
        return String((error as { message?: unknown }).message || '');
    }

    return String(error || InovxLoader.t('facility:externalAttributes.loadFailure'));
}

export async function loadExternalAttributeSourcesForFacility(facility: IFacility): Promise<ExternalSourceLoadResult> {
    try {
        const sources = await dataSourcesApi.getSources(facility.ID);
        return {
            Sources: sources
                .map(source => toExternalSourceCandidate(source))
                .sort((left, right) => left.Name.localeCompare(right.Name)),
        };
    } catch (error) {
        return {
            Sources: [],
            Error: getErrorMessage(error),
        };
    }
}
